import { render, staticRenderFns } from "./codingTool.vue?vue&type=template&id=37004c12&scoped=true"
import script from "./codingTool.vue?vue&type=script&lang=js"
export * from "./codingTool.vue?vue&type=script&lang=js"
import style0 from "./codingTool.vue?vue&type=style&index=0&id=37004c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37004c12",
  null
  
)

export default component.exports